import React, { useEffect, useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import { Container } from './styles'
import { Typography } from '@mui/material'
import ManageSearchIcon from '@mui/icons-material/ManageSearch'
import * as MechanicsService from '../../services/mechanics'
import { useHistory } from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'
import NewMechanicModal from './NewMechanicModal'
import { useModalContext } from '../../contexts/ModalContext'
import Table from '../../components/ui/Table'

const Mechanics = () => {
    const history = useHistory()
    const { setModal } = useModalContext()
    const [data, setData] = useState([])

    //pagination states
    const [tableLoading, setTableLoading] = useState(false)
    const [totalRows, setTotalRows] = useState(0)
    const [page, setPage] = useState(0)
    const [perPage, setPerPage] = useState(10)
    const [sortDirection, setSortDirection] = useState('ASC')
    const [sortBy, setSortBy] = useState('name')
    const [filterText, setFilterText] = useState('')

    const fetchTableData = async () => {
        setTableLoading(true)
        const response = await MechanicsService.getAllMechanics(page, perPage, sortBy, sortDirection, filterText)
        setData(response.content)
        setTotalRows(response.totalElements)
        setTableLoading(false)
    }

    useEffect(() => {
        fetchTableData()
    }, [page, perPage, sortDirection, sortBy, filterText])

    const columns = [
        {
            id: 'name',
            name: 'Nome',
            selector: (row) => row.name,
            sortable: true,
            width: '20%'
        },
        {
            name: 'Bandeira',
            selector: (row) => row.bandeira,
            width: '10%'
        },
        {
            name: 'Telefone',
            selector: (row) => row.phone,
            width: '10%'
        },
        {
            name: 'Cidade',
            selector: (row) => row.city,
            width: '10%',
            sortable: true
        },
        {
            name: 'Estado',
            selector: (row) => row.state,
            width: '10%',
            sortable: true
        },
        {
            name: 'Endereço',
            selector: (row) => row.address,
            width: '20%'
        },
        {
            name: 'Avaliação',
            selector: (row) => row.rate?.toFixed(1),
            width: '10%',
            sortable: true
        },
        {
            name: 'Detalhes',
            cell: (row) => (
                <Button
                    id={row.id}
                    variant='outlined'
                    onClick={() =>
                        history.push({
                            pathname: '/dashboard/mecânicas/detalhes',
                            state: { mechanic: row }
                        })
                    }
                >
                    <ManageSearchIcon />
                </Button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        }
    ]

    return (
        <Container>
            <Box mb={3} fontWeight='bold' fontSize={{ xs: 'h7.fontSize', sm: 'h6.fontSize', md: 'h5.fontSize' }}>
                Estabelecimentos
            </Box>
            <Box display='flex' flexDirection='row' justifyContent='space-between' mr={3}>
                <Button variant='outlined' onClick={() => setModal(<NewMechanicModal updateTable={fetchTableData} />)}>
                    <AddIcon fontSize='small' />
                    Novo Estabelecimento
                </Button>
                <Typography
                    fontSize={{
                        xs: 'h7.fontSize',
                        sm: 'h6.fontSize',
                        md: 'h6.fontSize'
                    }}
                >
                    Total: <b>{totalRows} Estabelecimentos</b>
                </Typography>
            </Box>
            <Box mt={3} mb={5}>
                <Card>
                    <Table
                        columns={columns}
                        data={data}
                        isPaginated={true}
                        filterLabel='Filtrar por Nome'
                        setPage={setPage}
                        setPerPage={setPerPage}
                        setSortBy={setSortBy}
                        setSortDirection={setSortDirection}
                        filterText={filterText}
                        setFilterText={setFilterText}
                        totalRows={totalRows}
                        loading={tableLoading}
                    />
                </Card>
            </Box>
        </Container>
    )
}

export default Mechanics
